import script from "./Admin-Datahub.vue?vue&type=script&setup=true&lang=js"
export * from "./Admin-Datahub.vue?vue&type=script&setup=true&lang=js"

import "./Admin-Datahub.vue?vue&type=style&index=0&id=2dacf248&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dacf248"]])

export default __exports__